import { useState, useEffect } from "react";
import { getByTypeInfo, getByTypeInfoNotLogin } from "api";

export default function useInformation(type, notLogin = false) {
	const [informations, setInformations] = useState([]);

	const getInformations = async () => {
		getByTypeInfo({ type }).then(async (res) => {
			setInformations(res.data);
		});
	};

	const getInformationsNotLogin = async () => {
		getByTypeInfoNotLogin({ type }).then(async (res) => {
			setInformations(res.data);
		});
	};

	useEffect(() => {
		if (type) {
			if (notLogin) {
				getInformationsNotLogin();
			} else {
				getInformations();
			}
		}
	}, [type]);

	return {
		informations,
	};
}
